var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/size-guide/conversion-select.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = (lineno = 0, colno = 32, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["selectedFit.availableConversions",[]]));
frame.set("availableConversions", t_1, true);
if(frame.topLevel) {
context.setVariable("availableConversions", t_1);
}
if(frame.topLevel) {
context.addExport("availableConversions", t_1);
}
output += "\n\n";
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "availableConversions")) > 1) {
output += "\n\n    <div class=\"o-row\">\n\n        <div class=\"o-column o-extra-small--12 o-medium--5 u-no-gutters c-form__field\">\n\n            <select id=\"size-guide-conversion\" class=\"c-form__select js-conversion-select\">\n\n                ";
frame = frame.push();
var t_4 = runtime.contextOrFrameLookup(context, frame, "availableConversions");
if(t_4) {var t_3 = t_4.length;
for(var t_2=0; t_2 < t_4.length; t_2++) {
var t_5 = t_4[t_2];
frame.set("conversion", t_5);
frame.set("loop.index", t_2 + 1);
frame.set("loop.index0", t_2);
frame.set("loop.revindex", t_3 - t_2);
frame.set("loop.revindex0", t_3 - t_2 - 1);
frame.set("loop.first", t_2 === 0);
frame.set("loop.last", t_2 === t_3 - 1);
frame.set("loop.length", t_3);
output += "\n\n                    ";
var t_6;
t_6 = (runtime.memberLookup((t_5),"slug") == runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "selectedConversion")),"slug"));
frame.set("selectedSlug", t_6, true);
if(frame.topLevel) {
context.setVariable("selectedSlug", t_6);
}
if(frame.topLevel) {
context.addExport("selectedSlug", t_6);
}
output += "\n                    ";
var t_7;
t_7 = (runtime.memberLookup((t_5),"displayName") == runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "selectedConversion")),"country"));
frame.set("selectedCountry", t_7, true);
if(frame.topLevel) {
context.setVariable("selectedCountry", t_7);
}
if(frame.topLevel) {
context.addExport("selectedCountry", t_7);
}
output += "\n\n                    <option value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_5),"slug"), env.opts.autoescape);
output += "\" ";
if(runtime.contextOrFrameLookup(context, frame, "selectedSlug") || runtime.contextOrFrameLookup(context, frame, "selectedCountry")) {
output += " selected ";
;
}
output += ">\n                        ";
output += runtime.suppressValue(runtime.memberLookup((t_5),"displayName"), env.opts.autoescape);
output += "\n                    </option>\n                ";
;
}
}
frame = frame.pop();
output += "\n\n            </select>\n\n        </div>\n\n    </div>\n\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/size-guide/conversion-select.j2"] , dependencies)